import React from 'react'
import VideoPlayer from '../PlainVideoPlayer'
import TButton from '../../wp-adons/TButton'

export default function Section ({ title, video_url, description, button_url }) {
  return (
    <div className='relative flex flex-col-reverse lg:flex-row z-10 w-full pl-0 lg:pl-24 gap-4 justify-start max-w-sitemax'>
      <div className='relative z-10 text-color_light w-full lg:w-auto flex flex-col items-center lg:block'>
        {title ? (
          <h2 className='text-header2 font-text_accent my-10'>{title}</h2>
        ) : (
          <></>
        )}

        {video_url && (
          <VideoPlayer
            className='relative z-0 w-full m-auto lg:mb-6  h-full max-h-[25svh]'
            videoSrc={video_url}
            autoPlay
            loop
            muted
          />
        )}
        {(button_url || description) && (
          <div className='max-w-2xl w-full lg:w-auto'>
            {description && (
              <div
                className='text-header4 font-text_readable my-8 px-6 lg:px-0'
                dangerouslySetInnerHTML={{
                  __html: description
                }}
              />
            )}
            {button_url && <TButton {...button_url} />}
          </div>
        )}
      </div>
    </div>
  )
}
